import { Wrench, Cpu, Building, Users, Battery, Droplets } from 'lucide-react';

export const services = [
  {
    icon: Wrench,
    title: "Mechanical Engineering",
    description: "Complete mechanical solutions for power and cement plants including boiler & turbine overhauls, piping systems, and heat exchanger services.",
    features: [
      "Boiler Maintenance & Overhaul (Pressure Parts, Super-heaters, Economisers)",
      "Turbine Maintenance — Alignment, Balancing, Blade Replacement",
      "HP/LP Piping Fabrication, Erection & Maintenance",
      "Heat Exchanger Cleaning, Re-tubing & Refurbishment",
      "Pump, Compressor & Cooling Tower Services"
    ],
    details: "Our mechanical engineering team specialises in power plant and cement plant machinery, ensuring optimal performance and minimal downtime."
  },
  {
    icon: Cpu,
    title: "Control & Instrumentation",
    description: "Advanced automation and instrumentation — SCADA, DCS, PLC system integration, calibration, loop checking and legacy system upgrades.",
    features: [
      "SCADA & DCS Implementation — Monitoring, Data Logging, Alarm Management",
      "PLC & System Integration linking all field instruments",
      "Transmitters, Flow Meters, Level/Pressure Gauges, Analysers",
      "Traceable-standard Calibration for Regulatory Compliance",
      "Legacy DCS/PLC Migration & Loop Checking / Pre-Commissioning"
    ],
    details: "We work with leading platforms including Siemens, ABB, Schneider Electric, and Honeywell for reliable automation solutions."
  },
  {
    icon: Building,
    title: "Civil Engineering Works",
    description: "Expert civil engineering for power and cement plant infrastructure — structural design, foundations, plant development and renovation.",
    features: [
      "Structural Design & Analysis",
      "Foundation & RCC Works",
      "Plant Infrastructure Development",
      "Roads & Building Construction",
      "Renovation & Repair Works"
    ],
    details: "Our civil team handles complete EPC projects from planning to execution with a focus on quality and timely delivery."
  },
  {
    icon: Users,
    title: "Manpower Services",
    description: "Technical and non-technical workforce for O&M and AMC — IBR-certified Boiler Operators, Engineers, Supervisors, and support staff.",
    features: [
      "Mechanical, C&I & Electrical Engineers and Supervisors",
      "Welders, Fitters, Riggers, Millwrights & IBR Boiler Operators",
      "Plant Helpers, Housekeeping, Security & Administrative Staff",
      "Full Operations & Maintenance (O&M) Teams",
      "Contract & Permanent Hiring with Training & Skill Development"
    ],
    details: "We deploy trained, experienced professionals ready to deliver excellence in plant operations and maintenance across India and internationally."
  },
  {
    icon: Battery,
    title: "BESS Services",
    description: "Battery Energy Storage System installation, commissioning, and annual maintenance — a 2025-26 added capability for the renewable energy sector.",
    features: [
      "BESS Installation & Pre-Commissioning",
      "Commissioning & System Integration",
      "Annual Maintenance Contracts (AMC)",
      "Performance Monitoring & Diagnostics",
      "Renewable Energy Plant Support"
    ],
    details: "Newly added in 2025-26: complete BESS lifecycle support for renewable energy plants requiring reliable energy storage solutions."
  },
  {
    icon: Droplets,
    title: "STP / ETP Services",
    description: "Annual Maintenance Contracts for Sewage Treatment Plants and Effluent Treatment Plants — ensuring compliance and operational continuity.",
    features: [
      "Sewage Treatment Plant (STP) AMC",
      "Effluent Treatment Plant (ETP) AMC",
      "Routine Inspection & Preventive Maintenance",
      "Equipment Servicing & Consumable Replacement",
      "Regulatory Compliance & Audit Support"
    ],
    details: "Newly added in 2025-26: STP and ETP annual maintenance services ensuring uninterrupted, compliant plant operation."
  }
];
